import { Api } from 'utils';

class ConversionService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/conversion/get',params),
		update: async (params?: any) => Api.createResponse('admin/conversion/update',params),
	}

}

export default ConversionService;